import React from 'react';

// Error boundary that catches the Kendo Chart + React 16 tooltip infinite-
// setState loop. Instead of crashing the entire dashboard, the boundary
// catches the error and shows a static fallback.
//
// This is a known issue: Kendo React Charts' internal Series tooltip
// component calls setState in onHideTooltip during the same render cycle,
// triggering React 16's "Maximum update depth" guard. A React 17+ upgrade
// resolves it; until then this boundary keeps the page functional.

export default class ChartBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch() {
    // Silently swallow — the chart will show a static fallback.
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '16px',
          color: 'var(--plk-text-muted)',
          fontSize: 'var(--plk-font-size-sm)',
          textAlign: 'center'
        }
      }, "Chart rendering paused. Upgrade to React 17+ to enable full chart interactivity.");
    }
    return this.props.children;
  }
}